// ResponsiveFrequencyView.jsx
import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Fab,
  TextField,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { auth } from "../../../_services";

const ResponsiveFrequencyView = ({
  data,
  userData,
  availabilityData,
  frequencyTypeData,
  isAdmin = false,
  jwt,
  t,
  onAdd,
  onDelete, 
  canManage
}) => {
  const userId = auth.getUserId(jwt);

  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [selectedAvailabilityId, setSelectedAvailabilityId] = useState(0);
  const [selectedFrequencyTypeId, setSelectedFrequencyTypeId] = useState("");
  const [frequencyValue, setFrequencyValue] = useState(1);
  const [note, setNote] = useState("");

  const grouped = data.reduce((acc, curr) => {
    const userName = userData.find(u => u.id === curr.anaUserId)?.name || "";
    if (!acc[userName]) acc[userName] = [];
    acc[userName].push(curr);
    return acc;
  }, {});

  const handleAdd = () => {
    console.log(selectedFrequencyTypeId);
    if (!selectedFrequencyTypeId) return;

    onAdd({
      id: -1,
      anaUserId: userId,
      availabilityId: selectedAvailabilityId,
      anaFrequencyTypeId: selectedFrequencyTypeId,
      frequencyValue,
      userNote: note,
    });
    setAddDialogOpen(false);
    setSelectedAvailabilityId(0);
    setSelectedFrequencyTypeId("");
    setFrequencyValue(1);
    setNote("");
  };

  const handleDelete = () => {
    onDelete(itemToDelete);
    setItemToDelete(null);
    setDeleteDialogOpen(false);
  };

  return (
    availabilityData.length > 0 && (
    <Box>
      {canManage && (
      <Tooltip title={t("addAvailabilityFrequency")} placement="top">
        <Fab
          color="primary"
          sx={{ position: "fixed", bottom: 36, left: 16, zIndex: 9999 }}
          onClick={() => {
            setAddDialogOpen(true);
            if (availabilityData.length > 0) {
              setSelectedAvailabilityId(availabilityData[0].id); // imposta il primo valore come default
            }
          }}
          
        >
          <AddIcon />
        </Fab>
      </Tooltip>
      )}
      {Object.entries(grouped).map(([user, items]) => (
        <Accordion key={user} sx={{ mb: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="bold">{user}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {items.map((item, idx) => {
              const isMine = item.anaUserId === userId;
              const availability = availabilityData.find(a => a.id === item.availabilityId)?.name || "";
              const freqType = frequencyTypeData.find(f => f.id === item.anaFrequencyTypeId)?.name || "";

              return (
                <Paper key={idx} sx={{ p: 2, mb: 1, backgroundColor: isMine ? "#ABEBC6" : "inherit", position: "relative" }}>
                  {canManage && isMine && (
                    <IconButton
                      size="small"
                      sx={{ position: "absolute", top: 4, right: 4 }}
                      onClick={() => {
                        setItemToDelete(item);
                        setDeleteDialogOpen(true);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                  <Typography variant="body2"><strong>{t("anaFrequencyTypeId")}:</strong> {freqType}</Typography>
                  <Typography variant="body2"><strong>{t("frequencyValue")}:</strong> {item.frequencyValue}</Typography>
                  {item.userNote && (
                    <Typography variant="body2"><strong>{t("userNote")}:</strong> {item.userNote}</Typography>
                  )}
                </Paper>
              );
            })}
          </AccordionDetails>
        </Accordion>
      ))}

      <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{t("addAvailabilityFrequency")}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal">
            <InputLabel>{t("anaFrequencyTypeId")}</InputLabel>
            <Select
              value={selectedFrequencyTypeId}
              label={t("anaFrequencyTypeId")}
              onChange={(e) => setSelectedFrequencyTypeId(e.target.value)}
            >
              {frequencyTypeData.map((f) => (
                <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            type="number"
            margin="normal"
            label={t("frequencyValue")}
            value={frequencyValue}
            onChange={(e) => setFrequencyValue(e.target.value)}
          />
          <TextField
            fullWidth
            label={t("userNote")}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            multiline
            rows={2}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddDialogOpen(false)}>{t("cancel")}</Button>
          <Button onClick={handleAdd} variant="contained" disabled={ !selectedFrequencyTypeId}>
            {t("confirm")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{t("confirmDelete")}</DialogTitle>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>{t("cancel")}</Button>
          <Button onClick={handleDelete} variant="contained" color="primary">
            {t("delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>)
  );
};

export default ResponsiveFrequencyView;
